import { useEffect, useState } from "react";

export default function CustomCursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    const enter = (e) => {
      const t = e.target;
      if (
        t instanceof Element &&
        (t.closest("a, button, [role='button'], input, textarea, select, [data-cursor='hover']"))
      ) {
        setHovering(true);
      }
    };
    const leave = (e) => {
      const t = e.target;
      if (
        t instanceof Element &&
        (t.closest("a, button, [role='button'], input, textarea, select, [data-cursor='hover']"))
      ) {
        setHovering(false);
      }
    };
    window.addEventListener("mousemove", move);
    document.addEventListener("mouseover", enter);
    document.addEventListener("mouseout", leave);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", enter);
      document.removeEventListener("mouseout", leave);
    };
  }, []);

  return (
    <>
      <div
        className="cursor-dot"
        style={{ transform: `translate3d(${pos.x}px, ${pos.y}px, 0) translate(-50%, -50%)` }}
      />
      <div
        className={`cursor-ring ${hovering ? "hovering" : ""}`}
        style={{ transform: `translate3d(${pos.x}px, ${pos.y}px, 0) translate(-50%, -50%)` }}
      />
    </>
  );
}
